'use client';

import { captureException } from '@sentry/nextjs';
import { useEffect } from 'react';
import { useLogger } from '@logtail/next';
import { PageErrorMessage } from '~/components/utility/error/page';

export default function GlobalError({
  error,
}: {
  error: Error & { digest?: string };
}) {
  const log = useLogger();

  useEffect(() => {
    captureException(error);
    log.error('Global error boundary caught error', {
      name: error.name,
      message: error.message,
      stack: error.stack,
      digest: error.digest,
      url: window.location.href,
    });
  }, [error]);

  return (
    <html>
      <body>
        <PageErrorMessage />
      </body>
    </html>
  );
}
